export default "__VITE_PUBLIC_ASSET__74fc916a__"